// extracted by mini-css-extract-plugin
module.exports = {"ui4":"var(--ui4)","tabs":"AdvancedFilterTabs_tabs__ZAZLj","panelWrapper":"AdvancedFilterTabs_panelWrapper__7vGvq"};